// extracted by mini-css-extract-plugin
export var logo = "_kb-2";
export var logoWrapper = "_kb-1";
export var strip = "_kb-0";